import React from "react";

interface ShippingSelectedProps {
    className?: string;
}

export const ShippingSelected: React.FC<ShippingSelectedProps> = ({ className }) => {
    return (
        <svg className={ className || '' } xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <circle cx="18" cy="18" r="18" fill="#37474F"/>
            <path d="M9.90002 18.1715L16.4655 24.3001L25.2 12.6001" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        </svg>
    )
}